import React, { useState } from 'react';
import PolygonSelector from '../components/PolygonSelector';

const PolygonSelectorTest: React.FC = () => {
  // Default to Mexico City location with existing GeoTIFF files
  const [coordinates, setCoordinates] = useState({
    lat: 19.422503,
    lng: -99.215131,
    name: 'Mexico City (Main Test)',
  });

  return (
    <div className="flex h-screen w-screen bg-gray-50 overflow-hidden">
      <PolygonSelector
        key={`${coordinates.lat}-${coordinates.lng}`}
        lat={coordinates.lat}
        lng={coordinates.lng}
      />
    </div>
  );
};

export default PolygonSelectorTest;
